import React from 'react';
import Nailserice from '../assets/nailser.jpeg';
import Hairwash from '../assets/hairwash.jpg';
import Hairr from '../assets/hairrr.jpg';
import smooth from '../assets/smooth.jpg';
import './Service.css';

const Hair = () => {
  return (
    <>
   <div className="homepageimg">
        <img src={Nailserice} alt="Beauty Destination" className="full-screen-image bgimg" />
   </div>
   <div className="d-flex justify-content-center pt-5">
  <h1 style={{ color: '#b37777', fontStyle: 'italic', fontFamily: "'TAN TWINKLE', cursive" }}> Hair Services</h1>
</div>

   <div className="container pt-4">
    <div className="row align-items-center animate-form servicecontainer">
        
        <div className="col-sm-6">
            <img src={Hairwash} alt="Nail Services" style={{width: "100%", height: "500px"}} />
        </div>
        <div className="col-sm-6">
          <h1 className="service-header text-center pt-2">Hair Wash & Refresh</h1>
          <p>
            Restore freshness and shine with our soothing Hair Wash service. Ideal for a clean, healthy look, it leaves your hair soft, 
            refreshed, and ready for any style. Perfect for a quick pick-me-up or pre-styling.
          </p>
            <p className="service-price"><strong>Pricing:</strong> Starts from $XX</p>
      </div>
    </div>
    <div className="row align-items-center animate-form1 servicecontainer">
      <div className="col-sm-6">
        <h1 className="service-header text-center">Hair Blow Dry</h1>
        <p>
          Transform your look with a sleek, voluminous blow dry. Adds shine, bounce, and long-lasting style, perfect for any event or everyday confidence. 
          Feel polished and effortlessly glamorous!         </p>
        <p className="service-price"><strong>Pricing:</strong> Starts from $XX</p>
    </div>
    <div className="col-sm-6">
      <img src={Hairr} alt="Nail Services" style={{width: "100%", height: "500px"}} />
  </div>
  </div>

<div className="row align-items-center animate-form servicecontainer">
  <div className="col-sm-6">
    <img src={smooth} alt="Nail Services" style={{width: "100%", height: "500px"}} />
</div>

  <div className="col-sm-6">
      <h1 className="service-header text-center pt-2">Keratin Smoothing</h1>
      <p>
        Get smooth, frizz-free hair with our Keratin Smoothing Treatment. Reduces frizz, enhances shine, and leaves your hair soft and silky. Enjoy long-lasting, effortless beauty!    
        </p>  
        <p className="service-price"><strong>Pricing:</strong> Starts from $XX</p>
  </div>
  
</div>
</div>









    </>
  )
}
export default Hair;